<template>
  <section id="intro" class="landing-section landing__intro">
    <transition name="fade">
      <div class="text-center mb-5" v-show="!loading">
        <img
          class="landing__intro__logo"
          src="@/assets/img/logo/logo_original.png"
          alt="Boxx Barber Shop Logo"
        />
        <br />
        <router-link class="btn btn-lg btn-boxx-red mt-4" to="/book">
          BOOK ONLINE NOW
        </router-link>
        <b-alert
          v-if="settings.landingAlertText"
          class="m-3"
          :variant="settings.landingAlertVariant || 'info'"
          show
        >
          {{ settings.landingAlertText }}
        </b-alert>
      </div>
    </transition>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      loading: true
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 300);
  },
  computed: mapGetters({
    settings: 'settings/settings'
  })
};
</script>
